{
  "INTEGRATION_APPS": {
    "FETCHING": "Fetching Integrations",
    "NO_HOOK_CONFIGURED": "There are no {integrationId} integrations configured in this account.",
    "HEADER": "Applications",
    "STATUS": {
      "ENABLED": "Enabled",
      "DISABLED": "Disabled"
    },
    "CONFIGURE": "Configure",
    "ADD_BUTTON": "Add a new hook",
    "DELETE": {
      "TITLE": {
        "INBOX": "Confirm deletion",
        "ACCOUNT": "Disconnect"
      },
      "MESSAGE": {
        "INBOX": "Are you sure to delete?",
        "ACCOUNT": "Are you sure to disconnect?"
      },
      "CONFIRM_BUTTON_TEXT": {
        "INBOX": "Yes, Delete",
        "ACCOUNT": "Yes, Disconnect"
      },
      "CANCEL_BUTTON_TEXT": "Cancel",
      "API": {
        "SUCCESS_MESSAGE": "Hook deleted successfully",
        "ERROR_MESSAGE": "Could not connect to chat server, Please try again later"
      }
    },
    "LIST": {
      "FETCHING": "Fetching integration hooks",
      "INBOX": "Inbox",
      "EDIT": {
        "BUTTON_TEXT": "Uredi"
      },
      "DELETE": {
        "BUTTON_TEXT": "Delete"
      }
    },
    "ADD": {
      "FORM": {
        "INBOX": {
          "LABEL": "Select Inbox",
          "PLACEHOLDER": "Select Inbox"
        },
        "SUBMIT": "Create",
        "CANCEL": "Cancel"
      },
      "API": {
        "SUCCESS_MESSAGE": "Integration hook added successfully",
        "ERROR_MESSAGE": "Could not connect to chat server, Please try again later"
      }
    },
    "EDIT": {
      "TITLE": "Uredi {name}",
      "FORM": {
        "SUBMIT": "Posodobi",
        "CANCEL": "Prekliči"
      },
      "API": {
        "SUCCESS_MESSAGE": "Integracijska povezava je bila uspešno posodobljena",
        "ERROR_MESSAGE": "Povezava s strežnikom klepeta ni uspela, poskusite znova pozneje"
      }
    },
    "CONNECT": {
      "BUTTON_TEXT": "Connect"
    },
    "DISCONNECT": {
      "BUTTON_TEXT": "Disconnect"
    },
    "SIDEBAR_DESCRIPTION": {
      "CUSTOM_DATA_PROVIDER": "Fetch data from your own server and display it in the conversation sidebar. Returns HTML (shown in an iframe) or JSON (shown as a key/value list).",
      "DIALOGFLOW": "Dialogflow is a natural language processing platform for building conversational interfaces. Integrating it with {installationName} lets bots handle queries first and transfer them to agents when needed. It helps qualify leads and reduce agent workload by answering FAQs. To add Dialogflow, create a Service Account in Google Console and share the credentials. Refer to the docs for details",
      "DAKTELA": "Sinhronizirajte e-pošto in spletne klepete s svojim računom daktela.",
      "RETINO": "Retino poskrbi za red pri upravljanju vračil in reklamacij.",
      "MAILSHIP": "Mailship je sistem za upravljanje skladišča in izpolnjevanja naročil. Preverite stanje naročila, sledenje in podrobnosti odpreme.",
      "RAYNET": "Povežite svoj račun Raynet CRM za dostop do podatkov o strankah. Dodajte povezavo s svojim uporabniškim imenom in API žetonom Raynet."
    },
    "TEST_CONNECTION": {
      "BUTTON": "Preizkusi povezavo",
      "SUCCESS": "Povezava uspešna",
      "ERROR": "Povezava ni uspela. Preverite svoje poverilnice."
    }
  }
}
